import { render, staticRenderFns } from "./ImageInputOther.vue?vue&type=template&id=6736f436&"
import script from "./ImageInputOther.vue?vue&type=script&lang=js&"
export * from "./ImageInputOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports